export default __webpack_public_path__ + "static/media/twitter-logo-png-twitter-logo-vector-png-clipart-library-518.b413b75b.png";